import {
  DRIFT_SITE_CONCIERGE_DIMENSIONS,
  DRIFT_SITE_CONCIERGE_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const SCTotalEndUsersThatHadAtLeastOneImpressionQuery: CubeQuery = {
  name: 'SCTotalEndUsersThatHadAtLeastOneImpressionQuery',
  queryName: 'SCTotalEndUsersThatHadAtLeastOneImpressionQuery',
  query: {
    measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
    filters: [
      {
        or: [
          {
            member: DRIFT_SITE_CONCIERGE_DIMENSIONS.SC_LOADED,
            operator: 'equals',
            values: ['1'],
          },
          {
            member: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_NAME,
            operator: 'equals',
            values: [
              'sc-chat-button-viewed',
              'sc-content-button-viewed',
              'sc-meeting-button-viewed',
              'sc-search-button-viewed',
            ],
          },
        ],
      },
    ],
  },
}

export const SCTotalEndUsersThatHadAtLeastOneEngagementActionQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneEngagementActionQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneEngagementActionQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          member: DRIFT_SITE_CONCIERGE_DIMENSIONS.ANY_APP_ENGAGEMENT,
          operator: 'equals',
          values: ['true'],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneChatButtonImpressionQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneChatButtonImpressionQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneChatButtonImpressionQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          member: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_NAME,
          operator: 'equals',
          values: ['sc-chat-button-viewed'],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneContentButtonImpressionQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneContentButtonImpressionQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneContentButtonImpressionQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          or: [
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_NAME,
              operator: 'equals',
              values: ['sc-content-button-viewed'],
            },
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.CONTENT_CLICKED,
              operator: 'equals',
              values: ['1'],
            },
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.CONTENT_PREVIEWED,
              operator: 'equals',
              values: ['1'],
            },
          ],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneMeetingButtonImpressionQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneMeetingButtonImpressionQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneMeetingButtonImpressionQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          or: [
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_NAME,
              operator: 'equals',
              values: ['sc-meeting-button-viewed'],
            },
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.MEETING_BOOKED,
              operator: 'equals',
              values: ['1'],
            },
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.MEETING_BUTTON_CLICK,
              operator: 'equals',
              values: ['1'],
            },
          ],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneSearchButtonImpressionQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneSearchButtonImpressionQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneSearchButtonImpressionQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          or: [
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_NAME,
              operator: 'equals',
              values: ['sc-search-button-viewed'],
            },
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.SEARCH_PERFORMED,
              operator: 'equals',
              values: ['1'],
            },
            {
              member: DRIFT_SITE_CONCIERGE_DIMENSIONS.SEARCH_BUTTON_CLICK,
              operator: 'equals',
              values: ['1'],
            },
          ],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneContentClickThroughQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneContentClickThroughQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneContentClickThroughQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          member: DRIFT_SITE_CONCIERGE_DIMENSIONS.CONTENT_CLICKED,
          operator: 'equals',
          values: ['1'],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneSearchPerformedQuery: CubeQuery = {
  name: 'SCTotalEndUsersThatHadAtLeastOneSearchPerformedQuery',
  queryName: 'SCTotalEndUsersThatHadAtLeastOneSearchPerformedQuery',
  query: {
    measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
    filters: [
      {
        member: DRIFT_SITE_CONCIERGE_DIMENSIONS.SEARCH_PERFORMED,
        operator: 'equals',
        values: ['1'],
      },
    ],
  },
}

export const SCTotalEndUsersThatHadAtLeastOneMeetingBookedQuery: CubeQuery = {
  name: 'SCTotalEndUsersThatHadAtLeastOneMeetingBookedQuery',
  queryName: 'SCTotalEndUsersThatHadAtLeastOneMeetingBookedQuery',
  query: {
    measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
    filters: [
      {
        member: DRIFT_SITE_CONCIERGE_DIMENSIONS.MEETING_BOOKED,
        operator: 'equals',
        values: ['1'],
      },
    ],
  },
}

export const SCTotalEndUsersThatHadAtLeastOneSearchClickThroughQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneSearchClickThroughQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneSearchClickThroughQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          member: DRIFT_SITE_CONCIERGE_DIMENSIONS.SEARCH_SOURCE_CLICK_THROUGH,
          operator: 'equals',
          values: ['1'],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneSearchButtonClickQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneSearchButtonClickQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneSearchButtonClickQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          member: DRIFT_SITE_CONCIERGE_DIMENSIONS.SEARCH_BUTTON_CLICK,
          operator: 'equals',
          values: ['1'],
        },
      ],
    },
  }

export const SCTotalEndUsersThatHadAtLeastOneContentPreviewQuery: CubeQuery = {
  name: 'SCTotalEndUsersThatHadAtLeastOneContentPreviewQuery',
  queryName: 'SCTotalEndUsersThatHadAtLeastOneContentPreviewQuery',
  query: {
    measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
    filters: [
      {
        member: DRIFT_SITE_CONCIERGE_DIMENSIONS.CONTENT_PREVIEWED,
        operator: 'equals',
        values: ['1'],
      },
    ],
  },
}

export const SCTotalEndUsersThatHadAtLeastOneMeetingButtonClickQuery: CubeQuery =
  {
    name: 'SCTotalEndUsersThatHadAtLeastOneMeetingButtonClickQuery',
    queryName: 'SCTotalEndUsersThatHadAtLeastOneMeetingButtonClickQuery',
    query: {
      measures: [DRIFT_SITE_CONCIERGE_MEASURES.COUNT_UNIQUE_END_USERS],
      filters: [
        {
          member: DRIFT_SITE_CONCIERGE_DIMENSIONS.MEETING_BUTTON_CLICK,
          operator: 'equals',
          values: ['1'],
        },
      ],
    },
  }
